import { render } from "./RoomsDetails.vue?vue&type=template&id=16945a3c"
import script from "./RoomsDetails.vue?vue&type=script&lang=js"
export * from "./RoomsDetails.vue?vue&type=script&lang=js"

import "./RoomsDetails.vue?vue&type=style&index=0&id=16945a3c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__